import { NavLink } from 'react-router-dom';
import '../styles/tracking.scss';


const Tracking=()=>{

    return (
        <div className='tracking'>

       <NavLink to={'/'}>
       <div className='logoArea'>
                        <div className='icon logo_initials'></div>
                        <div className='icon logo_name'></div>
        </div>
       </NavLink>
       
    

        <div className='centerbox'>

            <div className="titleside">
                <div className='ptitle'>Track Your Package</div>
                <div className='pinfo'>Real time updates, every step of the way</div>
            </div>


            <div className='inputside'>
                <div className='label'>Order ID</div>
                <div className='trackBox'>
                    <input placeholder='Your Order number'></input>
                    <button className='btn'>Track Order</button>
                </div>
            </div>


            <div className='trackresult'>
                <div className='etr'>
                    <div className='title'>Order Status:</div>
                    <div className='value'>Shipped</div>
                </div>

                <div className='etr'>
                    <div className='title'>Estimated delivery date:</div>
                    <div className='value'>April 18, 2025</div>
                </div>

                <div className='etr'>
                    <div className='title'>Tracking number:</div>
                    <div className='value'>YKXTP-4043</div>
                </div>

            </div>



            <div className='needhelp'>
            Need help?  visit &nbsp;
            <a href='https://yayakoexpress.com'>yayakoexpress.com</a>
            </div>


        </div>



    </div>
    )
}

export default Tracking